<template>
    <div class="bindPage rightPage">
        <div class="layout">
            <v-search
                :formContent="formContent"
                :SearchForm="SearchForm"
                :inline="true"
                :optareBtn="optareBtn"
                :treePathObj="treePathObj"
                @resetFn="resetFn"
                @confirmFn="getListFn"
                @searchFn="getListFn"
                @stopFn="stopFn"
                @netFn="netFn"
            />
            <div class="componentPage">
                <!--<STable :columns="columns" :req="relayList" :params="[SearchForm, 'unbind']" ref="stable" @selectData="choozeTable"></STable>-->
                <UnBindTable :loading='loading' :table-data='tableData' @stopUseFn="stopUseFn"
                             @choozeTable="choozeTable" @configFn="configFn" @detailFn="detailFn"></UnBindTable>
                <Pagination class="pagination" :total="total" :page.sync="SearchForm.iDisplayStart"
                            :limit.sync="SearchForm.iDisplayLength" @pagination="getListFn"></Pagination>
            </div>
        </div>
        <!-- 网络参数 -->
        <Net :isShow.sync="isShow" :title="title" :choozeTableData="choozeTableData" ref="net" />
        <!-- 配置信息 -->
        <Config :isShowConfig.sync="isShowConfig" :title="title" :rowData="rowData" v-bind="$attrs" ref="config" v-if="isShowConfig" />
    </div>
</template>

<script>
import getAllTreePath from '@/utils/getAllTreePath.js'
import { relayList, relayEdit } from '@/api/modules/relay.js'
import columns, { searchCondi } from '../config/unbindTable'
import Net from '../components/VNet.vue'
import bus from '@/utils/bus.js'
import qs from 'qs'
import Config from '../components/ConfigDialog.vue'
import UnBindTable from '@/pages/equipment/relay/unbind/UnTablePage.vue'
import { ENUM_DEVICE_WAY } from '@/common/enum/forward/device'
import { getIsPlatform, getPermission } from '@/utils/permission'
export default {
  mixins: [getAllTreePath],
  components: {
    UnBindTable,
    Net,
    Config
  },
  props: {
    selectDeviceType: {
      type: Array
    }
  },
  watch: {
    selectDeviceType: {
      handler (newval) {
        this.formContent[1].selectParam = newval
      },
      immediate: true
    }
  },
  computed: {
    /** 用于表示当前登录用户属于什么类型的角色 */
    sysAdmin () {
      return getPermission()
    },
    columns () {
      return columns.call(this)
    }
  },
  data () {
    return {
      formContent: searchCondi,
      SearchForm: {
        way: ENUM_DEVICE_WAY.UNBIND,
        iDisplayStart: 0,
        iDisplayLength: 15,
        code: null,
        type: null,
        scopeName: null,
        sceneId: null,
        carrierName: null,
        status: null,
        configurate: null
      },
      total: 0,
      loading: false,
      tableData: [],
      optareBtn: [
        {
          id: 1,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'public.stop',
          method: 'stopFn'
        },
        {
          id: 2,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'public.net_param',
          method: 'netFn'
        }
      ],
      choozeTableData: [],
      // 网络参数
      isShow: false,
      title: '',
      // 配置信息
      isShowConfig: false,
      // 把表格的数据也传递过去
      rowData: {}
    }
  },
  mounted () {
    bus.$on('nodeClickFn', row => {
      // 获取完整的路径
      this.getAllPath(row)
      this.treeClickSearchFn(row)
    })
    if (this.sysAdmin === 'noSysNoAdmin') {
      this.optareBtn.pop()
    }
    if (getIsPlatform()) {
      this.SearchForm.scopeName = this.$store.state.SchemaTree[1].label
      this.treePathObj = this.$store.state.SchemaTree[1].label
    } else {
      this.SearchForm.scopeName = this.$store.state.SchemaTree[0].label
      this.treePathObj = this.$store.state.SchemaTree[0].label
    }
    this.getListFn()
  },
  methods: {
    /** 分页 */
    getListFn () {
      // this.$refs.stable.getList()
      relayList(this.SearchForm, ENUM_DEVICE_WAY.UNBIND).then(({ result }) => {
        this.tableData = result.result
        this.total = result.pageInfo.total
      }).finally(() => {
        this.loading = false
      })
    },
    /** 点击树形查询 */
    treeClickSearchFn (row) {
      if (row.id === 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = null
      }
      // 一级范围
      else if (row.level === 0 && row.id !== 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = row.label
      } else {
        this.SearchForm.scopeName = null
        this.SearchForm.sceneId = row.sceneId
      }
      this.getListFn()
    },
    resetFn () {
      this.SearchForm = {
        way: 'unbind',
        startRecord: 0,
        iDisplayLength: 15,
        code: null,
        type: null,
        scopeName: null,
        sceneId: null,
        carrierName: null,
        status: null,
        configurate: null
      }
      if (getIsPlatform()) {
        this.SearchForm.scopeName = this.$store.state.SchemaTree[1].label
        this.treePathObj = this.$store.state.SchemaTree[1].label
      } else {
        this.SearchForm.scopeName = this.$store.state.SchemaTree[0].label
        this.treePathObj = this.$store.state.SchemaTree[0].label
      }
      bus.$emit('initTree')
      this.getListFn()
    },
    choozeTable (row) {
      this.choozeTableData = row
    },
    /** 多条停用 */
    stopFn () {
      if (this.choozeTableData.length === 0) return this.$message.warning(this.$t('public.least_one_data'))
      const idList = this.choozeTableData.map(item => item.id)

      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          const query = qs.stringify({ ids: idList.join(',') })
          relayEdit(query, 'unused').then(async ({ state }) => {
            await this.$resultHandle(state)

            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 单条中继停用 */
    stopUseFn (row) {
      const query = qs.stringify({ ids: row.id })
      relayEdit(query, 'unused').then(async ({ state }) => {
        await this.$resultHandle(state)

        this.getListFn()
      })
    },
    /** 网络参数弹出框 */
    netFn () {
      if (this.choozeTableData.length === 0) return this.$message.warning(this.$t('public.least_one_data'))
      this.isShow = true
      this.title = this.$t('device.add_net_param')
      this.$nextTick(() => {
        this.$refs.net.clearValidate()
      })
    },
    /** 配置 */
    configFn (row) {
      this.rowData = { ...row }
      console.log('rowdata', this.rowData)
      this.isShowConfig = true
      this.title = $t('public.config_info')
      this.$nextTick(() => {
        this.$refs.config.activeName = 'ConfigNet'
      })
    },
    /** 详情 */
    detailFn (row) {
      bus.$emit('relayParam', row.id, row.relayCode)
    }
  },
  beforeDestroy () {
    bus.$off('nodeClickFn')
  }
}
</script>

<style lang="scss" scoped>
.bindPage {
    .layout {
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;
    }

    .componentPage {
        flex: 1;

        .pagination {
            padding-top: 0;
            padding-right: 15px !important;
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }
}
</style>
